exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grid-element:hover .overlay {\n    background-color: transparent !important;\n}", ""]);

// exports
